// Catalan translations
export const ca: Record<string, string> = {
  'menu.dashboard': 'Tauler de control',
  'menu.customers': 'Clients',
  'menu.products': 'Productes',
  'menu.users': 'Usuaris',
  'menu.settings': 'Configuració',
  'menu.logout': 'Tancar sessió',
  'dashboard.title': 'Tauler de control',
  'dashboard.newOrder': 'Nova comanda',
  'order.title': 'Nova comanda',
  'order.customer': 'Client',
  'order.products': 'Productes',
  'order.total': 'Total',
  'users.title': 'Usuaris',
  'users.name': 'Nom',
  'users.email': 'Correu electrònic',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.cancel': 'Cancel·lar',
  'common.save': 'Desar',
  'common.search': 'Cercar',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Iniciar sessió',
  'login.welcome': 'Benvingut, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Correu electrònic',
  'signup.phone': 'Telèfon',
  'menu.reportsAndAccounting': 'Informes i comptabilitat',
  'menu.systemAndCommunication': 'Sistema i comunicació',
};